var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgHoveredArrow = function SvgHoveredArrow(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4684_169231)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.862549,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#1976D2",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.293 14.1556C20.4805 13.9681 20.7348 13.8628 21 13.8628C21.2652 13.8628 21.5195 13.9681 21.707 14.1556L27.707 20.1556C27.8945 20.3431 27.9998 20.5974 27.9998 20.8626C27.9998 21.1277 27.8945 21.3821 27.707 21.5696L21.707 27.5696C21.5184 27.7517 21.2658 27.8525 21.0036 27.8503C20.7414 27.848 20.4906 27.7428 20.3052 27.5574C20.1198 27.372 20.0146 27.1212 20.0123 26.859C20.01 26.5968 20.1108 26.3442 20.293 26.1556L24.586 21.8626H13C12.7348 21.8626 12.4804 21.7572 12.2929 21.5697C12.1054 21.3821 12 21.1278 12 20.8626C12 20.5974 12.1054 20.343 12.2929 20.1555C12.4804 19.9679 12.7348 19.8626 13 19.8626H24.586L20.293 15.5696C20.1055 15.3821 20.0002 15.1277 20.0002 14.8626C20.0002 14.5974 20.1055 14.3431 20.293 14.1556V14.1556Z",
    fill: "#1976D2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4684_169231"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.862549)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHoveredArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "hovered-arrow.c22d9c8e2ffe8443ea89c991fc6d1fb8.svg";